import type { SupplierPaymentFormValues } from '../types/supplierPaymentForm'

export const getSupplierPaymentFormDefaultValues = (): SupplierPaymentFormValues => ({
  accountId: '',
  amount: 0,
  entryDate: new Date(),
})
